import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import "../styles/horse-race.css";

const ReddyAnnaHorseRacePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="horse-race-betting-page">
      <Helmet>
        <title>Reddy Anna - Horse Race Betting India with Live Odds</title>
        <meta
          name="description"
          content="Experience horse race betting in India with Reddy Anna. Get real-time odds and secure betting ID."
        />

        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Service",
 "name": "Reddy Anna - Horse Race Betting India with Live Odds",
 "url": "https://reddyannaaid.com/horse-race-betting",
 "description": "Experience horse race betting in India with Reddy Anna. Get real-time odds and secure betting ID.",
 "provider": {
   "@type": "Organization",
   "name": "Reddy Anna"
 },
 "areaServed": "India"
}

          `}
        </script>
      </Helmet>
      <div className="horse-race-betting-intro">
        <div className="horse-race-betting-intro-content">
          <h1>
            <span>Reddy Anna Horse Race Betting:</span> Feel the Rush of the
            Track!
          </h1>
          <p>
            Step into the world of horse racing with Reddy Anna Horse Race
            Betting, where thrilling races meet exhilarating betting
            opportunities. Whether you're a passionate race fan or a newcomer to
            the sport, Reddy Anna offers an unmatched horse racing betting
            experience.
          </p>
          <div className="horse-race-betting-cta-buttons">
            <a
              href={whatsappLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Your Demo Account
            </a>
            <a
              href={ContactLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="horse-race-betting-intro-image">
          <img src="/horse-race-betting.webp" alt="Horse Race Betting" />
        </div>
      </div>

      <section className="horse-race-betting-features">
        <h2>
          Discover the Features of <span>Reddy Anna Horse Race Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Exclusive Reddy Anna ID:</strong> Unlock a world of horse
            racing excitement with your unique Reddy Anna ID, granting access to
            various races, tracks, and betting markets.
          </li>
          <li>
            <strong>Effortless Registration & Login:</strong> Quickly sign up
            and gain access to a wide array of races. Log in easily to place
            your bets on upcoming races and enjoy live action.
          </li>
          <li>
            <strong>Bet on the Go with Our App:</strong> Stay updated on all
            live races with the Reddy Anna Betting App. Bet anytime, anywhere,
            and never miss a moment of the excitement.
          </li>
          <li>
            <strong>Need Help? Contact Us:</strong> Reach out to us via WhatsApp
            or phone for any questions or assistance. Our friendly support team
            is always ready to help you with your betting experience.
          </li>
        </ol>
      </section>

      <section className="horse-race-betting-getting-started">
        <h2>
          Get Started with <span>Reddy Anna Horse Race Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Sign Up:</strong> Register on our platform or through the
            app and obtain your Reddy Anna ID to start betting on horse races.
          </li>
          <li>
            <strong>Log In:</strong> Once registered, log in securely to access
            the horse race betting section, where exciting races await.
          </li>
          <li>
            <strong>Browse Race Markets:</strong> Explore a variety of races,
            from local events to prestigious international competitions. Choose
            your favorites and start placing your bets.
          </li>
          <li>
            <strong>Place Your Bets:</strong> Select the race of your choice,
            analyze the odds, and place your bets. Enjoy live coverage and cheer
            for your chosen horse as they race toward victory!
          </li>
          <li>
            <strong>Need Assistance? Contact Us:</strong> Our team is available
            via WhatsApp or call to provide you with any assistance or support
            throughout your betting experience.
          </li>
        </ol>
        <div className="horse-race-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="horse-race-betting-join">
        <h2>
          Join <span>Reddy Anna</span> Today!
        </h2>
        <p>
          Dive into the thrilling world of horse racing with Reddy Anna Horse
          Race Betting. Bet with confidence, enjoy a seamless user experience,
          and access great odds with every race. Sign up now and experience the
          rush of the track!
        </p>
        <div className="horse-race-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ReddyAnnaHorseRacePage;
